export default __webpack_public_path__ + "static/iso-315059b5f5deba3d5adf0a552f9d822a.png";